module.exports = __webpack_public_path__ + "assets/img/nodata.4e41945a.png";